export const getUrl = () => {
  let url = window.location.origin,
    urlReturn = ''

  if (url.includes('https://admin.leadfrog.pro')) {
    urlReturn = 'https://map.leadfrog.pro/mapview/'
  }

  if (url.includes('https://admin.enterprise.leadfrog.pro')) {
    urlReturn = 'https://map.enterprise.leadfrog.pro/mapview/'
  }

  if (url.includes('https://admin.dev.leadfrog.pro')) {
    urlReturn = 'https://map.dev.leadfrog.pro/mapview/'
  }

  if (url.includes('https://admin.demo.leadfrog.pro')) {
    urlReturn = 'https://map.demo.leadfrog.pro/mapview/'
  }

  if (url.includes('https://admin.stage.leadfrog.pro')) {
    urlReturn = 'https://map.stage.leadfrog.pro/mapview/'
  }

  if (url.includes('https://admin.dev.demo.leadfrog.pro')) {
    urlReturn = 'https://map.dev.demo.leadfrog.pro/mapview/'
  }

  if (!urlReturn) {
    urlReturn = 'https://map.enterprise.leadfrog.pro/mapview/'
  }
  return urlReturn
}
